import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import {
  OfferButton,
  OfferButtonWrapper,
  OfferDesc,
  OfferDescWrapper,
  OfferImage,
  OfferItem,
  OfferItemTitle,
  OfferSection,
  OfferTitle,
  OfferWrapper,
} from "./OffersStyles"

const Offer = () => {
  const data = useStaticQuery(graphql`
    query Kolonie {
      kolonie: allWpCamp(sort: { fields: ACF_kolonie___order }) {
        nodes {
          title
          uri
          season {
            nodes {
              slug
            }
          }
          ACF_kolonie {
            test
            visibility
            cena
            shortDesc
            termin
            numberPlaces
            city
            fakultet
          }
          featuredImage {
            node {
              localFile {
                publicURL
              }
            }
          }
        }
      }
    }
  `)

  const renderOffers = seasonSlug =>
    data.kolonie.nodes
      .filter(post =>
        post.ACF_kolonie?.visibility &&
        !post.ACF_kolonie?.test && // ❌ NIE renderuj jeśli test === true
        post.season?.nodes?.[0]?.slug === seasonSlug
      )
      .map(post => (
        <OfferItem key={post.uri}>
           <Link to={post.uri.replace("kolonie/", "")}>
          <OfferImage>
            {post.featuredImage?.node?.localFile?.publicURL ? (
              <img
                alt="zdjęcie kolonii"
                src={post.featuredImage.node.localFile.publicURL}
              />
            ) : (
              <div className="placeholder">Brak zdjęcia</div>
            )}
          </OfferImage>
          </Link>

          <OfferDesc>
            <OfferDescWrapper>
              <OfferItemTitle>
                {post.title}
              </OfferItemTitle>

              <div className="OfferPrice">
                <span>cena: </span>
                <span className="price">{post.ACF_kolonie.cena}</span>
              </div>

              <div className="OfferDate">
                <span>
                  termin: <b>{post.ACF_kolonie.termin}</b>
                </span>
                <span>
                  miejsce: <b>{post.ACF_kolonie.city}</b>
                </span>

                {post.ACF_kolonie.fakultet ? (
                  <span>
                    fakultet: <b>{post.ACF_kolonie.fakultet}</b>
                  </span>
                ) : (
                  <div style={{ visibility: "hidden" }}>fakultet</div>
                )}
              </div>
            </OfferDescWrapper>

            <OfferButtonWrapper>
              <Link to={post.uri.replace("kolonie/", "")}>
                <OfferButton>Więcej</OfferButton>
              </Link>
            </OfferButtonWrapper>
          </OfferDesc>
        </OfferItem>
      ))

  return (
    <OfferSection id="kolonie">
      {/* <OfferTitle>Zimowiska</OfferTitle>
      <OfferWrapper>
        {renderOffers("zima")}
      </OfferWrapper> */}

      <OfferTitle>Kolonie letnie</OfferTitle>
      <OfferWrapper id="lato">
        {renderOffers("lato")}
      </OfferWrapper>
    </OfferSection>
  )
}

export default Offer
